const VIEWPORT_MARGIN = 12

export function floatingViewport() {
  const viewport = window.visualViewport
  return {
    left: viewport?.offsetLeft ?? 0,
    top: viewport?.offsetTop ?? 0,
    width: viewport?.width ?? window.innerWidth,
    height: viewport?.height ?? window.innerHeight,
  }
}

export function floatingSafeAreas(element: HTMLElement, prefix: string) {
  const css = getComputedStyle(element)
  const inset = (side: string) =>
    Math.max(0, Number.parseFloat(css.getPropertyValue(prefix + side)) || 0)
  return { left: inset('left'), top: inset('top'), right: inset('right'), bottom: inset('bottom') }
}

export function floatingViewportArea(element: HTMLElement, prefix: string) {
  const viewport = floatingViewport()
  const safe = floatingSafeAreas(element, prefix)
  const left = viewport.left + safe.left + VIEWPORT_MARGIN
  const top = viewport.top + safe.top + VIEWPORT_MARGIN
  const width = Math.max(0, viewport.width - safe.left - safe.right - VIEWPORT_MARGIN * 2)
  const height = Math.max(0, viewport.height - safe.top - safe.bottom - VIEWPORT_MARGIN * 2)
  return { left, top, width, height, right: left + width, bottom: top + height }
}
